/*eslint-disable*/ export const messages = { New: "Nouveau", "Remove {label}": ["Supprimer ", ["label"]] };
